export enum TABS {
    LicenseDetails,
    OfflineLicenses
}
